// import 'slick-carousel'
// import GOOGLEMAP from '../plugins/googlemap'
import GET_ARTICLES from '../plugins/getArticles'
import GET_CATEGORIES from '../plugins/getCategories'

const [w] = [window]

export default function HOME() {
  w.jQuery = $
  // map script
  // const km = w.siteinfo.mapApiKeys
  // const env_map_key = (!km[host]) ? km['local'] : km[host]
  // w.addScript({src:`https://maps.googleapis.com/maps/api/js?v=3&key=${env_map_key}&callback=load.mapScript.resolve`})

  $(() => {
  
    // トップページカスタム
    $.topInit();
  
    // ブロック整形
    (function(__){ $.each(__, $.topBlockCustomizer) }({
      'topics':{
        button:{
          disp: true,
          text: 'VIEW ALL',
          attr: {
            class: 'button button-inverse c-btn-icon-right'
          }
        },
        title:{
          html: '<span>NEWS</span><small>新着情報</small>' // プレーンテキストで動的にする場合は false
        },
        itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
          $this
            .append( $title.append($new) )
            .append( $catetitle )
            .append( $date )
            .append( $catch )
            .append( $body );
          // $date.insertAfter( $catetitle );
        }
      },
      // 'works':{
      //   title:{
      //     html: '<span>WORKS</span><small>施工事例</small>' // プレーンテキストで動的にする場合は false
      //   },
      //   itemlayout: function($this,$catetitle,$date,$new,$title,$catch,$body){
      //     $this
      //       .append( $title.append($new) )
      //       .append( $catetitle )
      //       .append( $date )
      //       .append( $catch )
      //       .append( $body );
      //     // $date.insertAfter( $catetitle );
      //   }
      // },
    }));
  
    /*****
     * Slick実行
     */
    // $('[data-plugin="slider"]').slick({
    //   autoplay:true,
    //   fade: true,
    //   dots: true,
    //   speed: 1200,
    //   autoplaySpeed: 4000,
    //   pauseOnHover: false,
    //   pauseOnFocus: false,
    //   arrows: true
    // })

    // ticker
    w.load['mainvisual'].done(() => {
      GET_ARTICLES('.p-mainvisual__ticker [data-plugin="getArticles"]',{
        makeItem(item,opt){
          return $(`<div class="p-mainvisual__ticker-item__inner">
          <p class="date">${item.date}</p>
          <a href="${item.href}" class="title">
            ${item.title}<span class="category">［${item.category.name}］</span>
          </a>
        </div>`)[0]
        }
      })
    });

    w.load['block-news'].done(()=> {
      // GET_ARTICLES('.p-block-news__head [data-plugin="getArticles"]',{
      //   makeItem(item,opt){
      //     return $(`<a href="${category.href}" class="category"><span>${item.category}</span></a>`)[0]
      //   }
      // });
      GET_CATEGORIES('.p-block-news__head[data-plugin="getCategories"]',{
        addAll: true,
        itemClass: 'head-category'
      });
      GET_ARTICLES('.p-block-news__inner [data-plugin="getArticles"]',{
        makeItem(item,opt){
          return $(`
            <a href="${item.href}" class="p-block-news__item">
              <div class="body">
                <span class="date">${item.date}</span>
                <small class="category">${item.category.name}</small>
                <h5 class="title">${item.title}</h5>
              </div>
            </a>`)[0]
        }
      });
    })

  
  });

    
  // map
  // document.addEventListener( 'DOMContentLoaded', () => {
  //   $.when(
  //     w.load['mapScript'],
  //     w.load['contentFooter']
  //   ).done( () => GOOGLEMAP() )
  // } )
}